import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "../../Utils/Loaders";
import userManager from "../../../auth/userManager";

const CallbackPage = (props: any) => {

  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      try {
        const user = await userManager.signinCallback();
        const locationURL = GetUrlPath(user?.state?.returnUrl);
        navigate(locationURL || "/", { replace: true });
      } catch (error: any) {
        const msg = error?.message ?? String(error);
        if (msg.includes('No matching state found in storage')) {
          try {
            if (typeof (userManager as any).clearStaleState === 'function') {
              await (userManager as any).clearStaleState();
            }
            await userManager.removeUser();
          } catch {}
          await userManager.signinRedirect();
          return;
        }
        navigate('/', { replace: true });
      }
    };
    run();
  }, [navigate]);

  return <Spinner />;
}

const GetUrlPath = (url: string): string => {
  if (!url) {
    return "/";
  }
  return new URL(url).pathname;
}

export default CallbackPage;